<div class="page-header border-bottom">
    <h3>Direct Deposit</h3>
</div>
<div class="container" id="modal_size">
    <div>
        <a routerLink="/careers/tasks" class="btn btn-primary" style="margin-bottom:15px;">
            <i class="modus-icons align-bottom">chevron_left</i>Back
        </a>
    </div>
    <div style="text-align:left;z-index:100;margin-top:-25px;float:right;">
        <span *ngIf="lastSave.status ==='success' && lastSave.time != null" class="badge badge-success" [ngClass]="{fade: formData.labelFade}">Save Successful - {{lastSave.time}}</span>
        <span *ngIf="lastSave.status !=='success' && lastSave.time != null" class="badge badge-danger" [ngClass]="{fade: formData.labelFade}">Save Fail - {{lastSave.time}}</span>
    </div>
    <div [hidden]="oNDDCustomText == null">
        <quill-view [content]="oNDDCustomText"></quill-view>
    </div>
    <div>
        <form #directDeposit="ngForm">
            <div *ngFor="let data of accountList;let $index = index">
                <div class="card border mb-3">
                    <div class="card-header bg-light">{{accountName[$index]}} Account</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-2">
                                <label><strong>Routing #</strong></label>
                                <input class="form-control"
                                       type="text"
                                       name="RoutingID + {{$index}}"
                                       [(ngModel)]="data.RoutingID"
                                       (ngModelChange)="validateRouter(data, $index)"
                                       [required]="data.RoutingID == null || data.RoutingID === ''"
                                       [ngClass]="{invalidField: data.RoutingID == null || data.RoutingID === '' || data.Invalid}" maxlength="{{maxRouterNumber}}" />
                                <span style="color:red;" *ngIf="data.Invalid">Routing must be {{maxRouterNumber}} digits</span>
                            </div>
                            <div class="col-lg-2">
                                <label><strong>Account #</strong></label>
                                <input class="form-control"
                                       type="text"
                                       name="BankAcct + {{$index}}"
                                       [(ngModel)]="data.BankAcct"
                                       [required]="data.BankAcct == null || data.BankAcct === ''"
                                       (blur)="checkAccount()"
                                       [ngClass]="{invalidField: data.BankAcct == null || data.BankAcct === '' || duplicateAccount}" maxlength="17" />
                            </div>
                            <div class="col-lg-2">
                                <label><strong>Account Type</strong></label>
                                <div [ngClass]="{invalidField: data.AcctType == null}">
                                    <div>
                                        <input type="radio" name="Checking + {{$index}}" [(ngModel)]="data.AcctType" value="C" [required]="data.AcctType == null" />
                                        Checking
                                    </div>
                                    <br />
                                    <div>
                                        <input type="radio" name="Savings + {{$index}}" [(ngModel)]="data.AcctType" value="S" [required]="data.AcctType == null" />
                                        Savings
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div *ngIf="$index != 0">
                                    <label><strong>Savings Method</strong></label>
                                    <div [ngClass]="{invalidField: data.Method == null}">
                                        <div>
                                            <input type="radio" name="Percent + {{$index}}" [(ngModel)]="data.Method" value="P" [required]="data.Method == null" (change)="resetValue(data)" />
                                            Percent
                                        </div>
                                        <br />
                                        <div>
                                            <input type="radio" name="Amount + {{$index}}" [(ngModel)]="data.Method" value="A" [required]="data.Method == null" (change)="resetValue(data)" />
                                            $ Amount
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2" *ngIf="data.Method != null && $index != 0">
                                <label *ngIf="data.Method === 'A'"><strong>Amount</strong></label>
                                <label *ngIf="data.Method === 'P'"><strong>Percent</strong></label>
                                <div>
                                    <input type="text"
                                           name="AmountValue + {{$index}}"
                                           currencyMask [options]="options"
                                           class="form-control"
                                           *ngIf="data.Method === 'A'"
                                           [(ngModel)]="data.Amount"
                                           placeholder="{{currencySymbol}}"
                                           [ngClass]="{invalidField: data.Amount == null || data.Amount === ''}"
                                           [required]="data.Amount == null || data.Amount === ''" />
                                    <input type="text"
                                           name="PercentValue + {{$index}}"
                                           appPercentNumber
                                           (valueChange)="updatePercentage($event,data)"
                                           class="form-control"
                                           *ngIf="data.Method === 'P'"
                                           [(ngModel)]="data.Pct"
                                           placeholder="%"
                                           (blur)="checkAllPct()"
                                           [ngClass]="{invalidField: data.Pct == null || data.Pct === '' || totalPctOver100}"
                                           [required]="data.Pct == null || data.Pct === ''" />
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-lg-5" *ngIf="data.Attachments == null">
                                <div ngfDrop
                                     selectable="1"
                                     class="drop-box"
                                     [(files)]="data.Attachments"
                                     (filesChange)="upload(data, $index)"
                                     [(validDrag)]="validComboDrag"
                                     accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
                                     [(dragFiles)]="dragFiles"
                                     [class.invalid-drag]="validComboDrag===false"
                                     [class.valid-drag]="validComboDrag"
                                     [ngClass]="{'requireAtt': data.Attachments == null}"
                                     name="filedrop + {{$index}}"
                                     [ngfFixOrientation]="false">Drop a file or Click to upload</div>
                            </div>
                            <div class="col-lg-5" *ngIf="data.Attachments != null">
                                <div class="progress mb-2" style="width:250px;" *ngIf="data.Attachments.Progress > 0">
                                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': data.Attachments.Progress + '%' }">{{data.Attachments.Progress}}%</div>
                                </div>
                                {{data.Attachments.AttachmentFileName}}
                                <button class="btn btn-danger btn-icon-only" (click)="deleteAttachment(data)" formnovalidate>
                                    <i class="modus-icons">trash</i>
                                </button>
                            </div>
                            <div class="col-lg-7">
                                <button class="btn btn-danger float-right" type="button" style="margin-top:10px;" (click)="deleteOnboardDirectDeposit(data, $index)" *ngIf="$index != 0">Remove Account</button>
                            </div>
                        </div>
                        <span>Supported file formats: .pdf, .jpg, .gif, .tif, .png, .bmp, .doc(x), .xls(x), .ppt(x), .pps(x), .sldx</span>
                    </div>
                </div>
            </div>
            <button class="btn btn-primary" type="button" (click)="addAccount()" [disabled]="accountList.length > 3">Add Another Account</button>
            <button class="btn btn-success float-right" type="button" (click)="saveDirectDeposit()" [disabled]="directDeposit.form.invalid || invalidRouterCount > 0 || missAttachCount > 0 || totalPctOver100 || duplicateAccount">Save</button>
        </form>
    </div>
</div>
